import { PureComponent } from "react";
import wrap from "word-wrap";

type Props = {
  text: string;
};

export default class Comment extends PureComponent<Props> {
  render() {
    return (
      <div className="cm-comment" style={{ whiteSpace: "pre" }}>
        {wrap(this.props.text || "n/a", { width: 70, indent: "" }).replace(/(^|\n)/g, "$1# ")}
      </div>
    );
  }
}
